// extracted by mini-css-extract-plugin
export var aniSpin = "z_d";
export var close = "z_X";
export var el = "z_b";
export var inner = "z_r";
export var logo = "z_W";